import React, {useEffect} from 'react';
import { connect } from "react-redux";
import {FormattedMessage} from "react-intl";

import Quote from "./quote";
import {updateCurrentQuote} from "../../misc/quotesFunctions";
import {setActiveQuoteIndex, setQuotes} from "../../actions/roomsFunctions";
import goToMaterialPage from "../../bvcomponents/common/goToMaterialPage";
import {changeActivePartRelatedItemIndex} from "../../actions/actionFunctions";
import BodySwipable from "../visComponents/navigation/desktop/bodySwipable";
import {switchToNewVisualizerType} from "../../misc/visualizerSwitchingFunctions";

const Quotes = (props) => {

  const {quotes, activeQuoteIndex, fabricatorSettings} = props;

  const updateAllQuotes = async () => {
    if (fabricatorSettings.allowVisualizerSwitching && quotes[activeQuoteIndex] && quotes[activeQuoteIndex].room
      && (quotes[activeQuoteIndex].room !== document.kvConfig.visualizerType)) {
      await switchToNewVisualizerType(quotes[activeQuoteIndex].room) // cases when someone in another category and didn't create a quote yet
    }
    for (const [currentQuoteIndex, currentQuote] of quotes.entries()) {
      if ((activeQuoteIndex === currentQuoteIndex && !document.kvConfig.jobId) || (!currentQuote.staticCanvasImage && !currentQuote.bvImage)) {
        // update quote if it has no image (created in sqft for example)
        await updateCurrentQuote(currentQuoteIndex);
      }
    }
  }

  useEffect(() => {
    updateAllQuotes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // useEffect(() => {
  //   if (!fabricatorSettings.allowVisualizerSwitching || visualizerIsChanging) { // don't do anything until it is switched (incorrect picture issue)
  //     return
  //   }
  //   updateAllQuotes();
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [visualizerIsChanging]);

  const addNewQuote = async () => {
    const currentQuote = await updateCurrentQuote();
    const newQuotes = [...currentQuote, {}];
    props.setQuotes(newQuotes);
    props.setActiveQuoteIndex(newQuotes.length - 1);
    props.changeActivePartRelatedItemIndex(0);
    goToMaterialPage("shoppingcart", true);
    await updateCurrentQuote(); // new quote, create quote img
  };

  return (
    <BodySwipable className="quotes" scrollableSelector={".quotes-list"}>
      <ul className="quotes-list">
        {quotes.map((quote, index) => {
          return <Quote quote={quote} quoteIndex={index} key={index}/>
        })}
        <li className="quotes-list__item quotes-list__item--add" onClick={addNewQuote}>
          <FormattedMessage id="addRoomButtonText"/>
        </li>
      </ul>
    </BodySwipable>
  )
};

const mapStateToProps = (store) => {
  // const {visualizerIsChanging} = store.serverState;
  const {settings} = store.fabricatorState;
  return {
    quotes: store.quotesState.quotes,
    activeQuoteIndex: store.quotesState.activeQuoteIndex,
    // visualizerIsChanging,
    fabricatorSettings: settings,
  };
};

const mapDispatchToProps = {
  setActiveQuoteIndex,
  setQuotes,
  changeActivePartRelatedItemIndex,
};

export default connect(mapStateToProps, mapDispatchToProps)(Quotes);
